export default {
    red: '#ff4778',
    purple: '#7633ff',
    white: '#ffffff',
    lightGray: '#9f9da3',
};
